module.exports = __webpack_public_path__ + "static/media/5.75333744.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/share/img/5.png
// module id = 1536
// module chunks = 0